import { render, staticRenderFns } from "./AllocationTotalTable.vue?vue&type=template&id=384cc87a&scoped=true"
import script from "./AllocationTotalTable.vue?vue&type=script&lang=js"
export * from "./AllocationTotalTable.vue?vue&type=script&lang=js"
import style0 from "./AllocationTotalTable.vue?vue&type=style&index=0&id=384cc87a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384cc87a",
  null
  
)

export default component.exports